import { NgModule } from "@angular/core";
import { EmployeeListComponent } from "./employee-list/employee-list.component";
import { EmployeeModalComponent } from "./employee-modal/employee-modal.component";
import { AuthGuard } from "../../util/guard/auth.guard";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgSelectModule } from "@ng-select/ng-select";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ComponentsModule } from "../../util/components/components.module";
import { NgbAlertModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { OfficesResolver } from "../../util/resolver/offices.resolver";

const routes = [
  {
    path: "employees",
    component: EmployeeListComponent,
    canActivate: [AuthGuard],
    resolve: {
      offices: OfficesResolver,
    },
  },
];

@NgModule({
  declarations: [EmployeeListComponent, EmployeeModalComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    CoreCommonModule,
    NgxDatatableModule,
    NgSelectModule,
    SweetAlert2Module,
    ComponentsModule,
    NgbNavModule,
    NgbAlertModule,
  ],
})
export class EmployeesModule {}
